<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="d-flex align-items-center text-nowrap">
                    <b-button
                        class="mr-2"
                        variant="outline-primary"
                        v-if="$route.query.parentId"
                        @click="back"
                    >
                        <i class="fa fa-arrow-left mr-2"></i>
                        <span class="text-uppercase">Quay lại</span>
                    </b-button>
                    <b-button class="mr-2" variant="outline-primary" @click="openCreateFolderModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Tạo thư mục</span>
                    </b-button>
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Thêm tệp dữ liệu</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="items"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
            >
                <template #cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template #cell(path)="data"
                    ><span>
                        <b-link
                            v-if="data.item.type == CONSTANTS.GEOJSON_TYPE.FOLDER"
                            @click="goToFolder(data.item.id)"
                            >{{ data.value }}</b-link
                        >
                        <span v-else>{{ data.value }}</span>
                    </span></template
                >
                <template v-slot:cell(type)="data">
                    <b-badge
                        class="px-2 py-1 font-12"
                        :variant="
                            data.value === CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN
                                ? 'primary'
                                : data.value === CONSTANTS.GEOJSON_TYPE.OTHER
                                ? 'secondary'
                                : data.value === CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN
                                ? 'info'
                                : data.value === CONSTANTS.GEOJSON_TYPE.FOLDER
                                ? 'warning'
                                : data.value === CONSTANTS.GEOJSON_TYPE.XLSX
                                ? 'success'
                                : data.value === CONSTANTS.GEOJSON_TYPE.PNG
                                ? 'light'
                                : 'danger'
                        "
                        >{{
                            data.value === CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN
                                ? 'Mưa'
                                : data.value === CONSTANTS.GEOJSON_TYPE.OTHER
                                ? 'Khác'
                                : data.value === CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN
                                ? 'Dự báo mưa'
                                : data.value === CONSTANTS.GEOJSON_TYPE.FOLDER
                                ? 'Thư mục'
                                : data.value === CONSTANTS.GEOJSON_TYPE.SCRIPT_FLOOD
                                ? 'Kịch bản lụt'
                                : data.value === CONSTANTS.GEOJSON_TYPE.XLSX
                                ? 'Excel'
                                : data.value === CONSTANTS.GEOJSON_TYPE.PNG
                                ? 'Ảnh'
                                : 'Lụt'
                        }}</b-badge
                    >
                </template>
                <template #cell(time)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template #cell(actions)="row">
                    <b-button
                        variant="success"
                        v-b-tooltip.hover
                        class="min-width-none mr-2"
                        title="Tải về"
                        v-if="row.item.type != CONSTANTS.GEOJSON_TYPE.FOLDER"
                        @click="downloadItem(row.item.path)"
                    >
                        <i class="fa fa-download"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item.id)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có bản ghi nào</span>
                    </div>
                </template>
            </b-table>
            <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="countRow"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                    first-number
                    last-number
                />
            </div>

            <!-- Create/Edit Info -->
            <b-modal
                ref="createOrUpdateModal"
                ok-title="Tải lên"
                title="Tải lên tệp mới"
                :cancel-title="$t('common.cancel')"
                @ok="handleCreateOk"
                no-close-on-esc
                no-close-on-backdrop
            >
                <b-form-group label="Tệp">
                    <b-form-file
                        browse-text="Chọn tệp"
                        v-model="fileUpload"
                        placeholder="Chọn tệp từ máy tính của bạn"
                        accept="image/*, .geojson"
                    />
                </b-form-group>
                <b-form-group label="Loại tệp">
                    <b-form-radio-group
                        v-model="itemInfo.type"
                        :options="CONSTANTS.GEOJSON_RADIO_TYPE"
                        name="radio-type"
                    />
                </b-form-group>
                <b-form-group label="Thời gian">
                    <RDateTimePicker @updateValue="onChangeDate" :type="'datetime'" />
                </b-form-group>
            </b-modal>

            <b-modal
                ref="createOrUpdateFolderModal"
                ok-title="Tạo"
                title="Tạo thư mục mới"
                :cancel-title="$t('common.cancel')"
                @ok="handleCreateFolderOk"
                no-close-on-esc
                no-close-on-backdrop
            >
                <b-form-group label="Tên thư mục">
                    <b-form-input
                        maxlength="255"
                        v-model="itemInfo.name"
                        placeholder="Tên thư mục"
                        name="folderName"
                        v-validate="'required'"
                        data-vv-as="Tên thư mục"
                    ></b-form-input>
                </b-form-group>
            </b-modal>

            <!-- Confirm Delete -->
            <b-modal
                ref="deleteModal"
                :title="$t('common.confirmation')"
                no-close-on-esc
                no-close-on-backdrop
                :ok-title="$t('common.delete')"
                :cancel-title="$t('common.cancel')"
                ok-variant="danger"
                @ok="onDelete"
                >Bạn có chắc chắn muốn xoá tệp này?</b-modal
            >
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import CONSTANTS from '@/constants';
import API_CONFIG from '@/api-config';
import RDateTimePicker from '@/components/RDateTimePicker';
import axios from 'axios';
export default {
    components: {
        RDateTimePicker
    },
    async mounted() {
        await this.$nextTick();
        await this.getList();
        this.items = this.geojsonItems.filter(
            (item) => item.parentId == this.$route.query.parentId
        );
    },
    computed: {
        ...mapState({
            geojsonItems: (state) => state.geojson.items
        }),
        countRow() {
            return this.items.length;
        }
    },
    watch: {
        '$route.query.parentId'() {
            this.items = this.geojsonItems.filter(
                (item) => item.parentId == this.$route.query.parentId
            );
            this.currentPage = 1;
        },
        geojsonItems() {
            this.items = this.geojsonItems.filter(
                (item) => item.parentId == this.$route.query.parentId
            );
        }
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'path', label: 'Tên file' },
                { tdClass: 'align-middle', key: 'type', label: 'Kiểu lưu trữ' },
                {
                    tdClass: 'align-middle',
                    key: 'time',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            currentPage: 1,
            CONSTANTS,
            currentId: null,
            itemInfo: {},
            fileUpload: null,
            items: []
        };
    },
    methods: {
        ...mapActions({
            getList: 'geojson/getList',
            deleteItem: 'geojson/deleteGeoJson',
            uploadFileToServer: 'geojson/uploadFile'
        }),
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteItem({ id: this.currentId });
            if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá tệp thành công!');
            this.getList();
        },
        async confirmDelete(id) {
            this.currentId = id;
            this.$refs.deleteModal.show();
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        openCreateFolderModal() {
            this.resetForm();
            this.$refs.createOrUpdateFolderModal.show();
        },
        resetForm() {
            this.itemInfo = {
                type: this.CONSTANTS.GEOJSON_RADIO_TYPE[0].value
            };
        },
        async handleCreateOk(modal) {
            modal.preventDefault();
            await this.uploadFile();
            this.$refs.createOrUpdateModal.hide();
            this.$toaster.success('Tải lên tệp thành công');
            setTimeout(() => {
                this.getList();
            }, 200);
        },
        async handleCreateFolderOk(modal) {
            modal.preventDefault();
            await this.createFolder();
            this.$refs.createOrUpdateFolderModal.hide();
            this.$toaster.success('Tạo thư mục thành công');
            setTimeout(() => {
                this.getList();
            }, 200);
        },
        onChangeDate(date) {
            this.itemInfo.time = date;
        },
        uploadFile() {
            const formData = new FormData();
            formData.append('file', this.fileUpload);
            formData.append('time', this.itemInfo.time);
            formData.append('type', this.itemInfo.type);
            if (this.$route.query.parentId) formData.append('parentId', this.$route.query.parentId);
            this.uploadFileToServer(formData);
        },
        createFolder() {
            const formData = new FormData();
            formData.append('name', this.itemInfo.name);
            formData.append('type', 'FOLDER');
            if (this.$route.query.parentId) formData.append('parentId', this.$route.query.parentId);
            this.uploadFileToServer(formData);
        },
        goToFolder(parentId) {
            const query = { ...this.$route.query, parentId: parentId };
            this.$router.replace({ query });
        },
        downloadItem(path) {
            axios
                .get(API_CONFIG.BASE_URL + 'geojson' + path, { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'application/txt' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = path;
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(console.error);
        },
        back() {
            const parent = this.geojsonItems.find((item) => item.id == this.$route.query.parentId);
            this.goToFolder(parent.parentId);
        }
    }
};
</script>
